export enum EVENT {
  PAGE_LOAD = 1000000001,
  TOOLTIP_HOVERED = 1000000002,
  BUTTON_CLICKED = 1000000003,
  MODAL_OPENED = 1000000004,
}
